var _rect, _rect2, _rect3, _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayiMarkOnDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 57,
    width: 62,
    height: 62,
    rx: 13,
    transform: "rotate(45 60 88)",
    fill: "#1a5a75"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 43,
    width: 62,
    height: 62,
    rx: 13,
    transform: "rotate(45 60 74)",
    fill: "#2d7290"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 29,
    width: 62,
    height: 62,
    rx: 13,
    transform: "rotate(45 60 60)",
    fill: "#cdd32e"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 48,
    r: 5.5,
    fill: "#082d40"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 48,
    r: 5.5,
    fill: "#082d40"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 61 L75 61 A15 15 0 0 1 45 61 Z",
    fill: "#082d40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayiMarkOnDark);
export default __webpack_public_path__ + "static/media/layi-mark-on-dark.f29f41d0472237cbf44e149f7cddd20b.svg";
export { ForwardRef as ReactComponent };